import useTenant from './useTenant';
import useCollectionSubscription from './useCollectionSubscription';

export default function useCollectionSubscriptionInTenant(ref, dependencies = [], ...args) {
  const tenant = useTenant();
  const refWithTenant = ref && tenant && ref.where('tenantId', '==', tenant.id);

  return useCollectionSubscription(refWithTenant, [...dependencies, tenant], ...args);
}
